
import moment from 'moment';
import { callApi } from 'api';
import { notify } from 'actions';

import {
	SET_CURRENT_MAP,
	UPDATE_MAP,
	UPDATE_MAP_SEARCH_LIST,
	SEARCHING_MAPS,
	DONE_SEARCHING_MAPS,
	UPDATE_PLACES,
	SET_PURCHASE_MAP,
	HIDE_PURCHASE_MAP,
	SHOW_PURCHASE_MAP,
	UPDATE_DATE,
	UPDATE_STORM_DATA
} from 'constants';

//Action Creators
export function updatePlaces(places) {
	return {
		type: UPDATE_PLACES,
		places
	}
}

export const updateDate = (date) => {
	return {
		type: UPDATE_DATE,
		date
	}
}

export const updateStormData = (stormData) => {
	return {
		type : UPDATE_STORM_DATA,
		stormData
	}
}

export function setCurrentMap(map) {
	return {
		type : SET_CURRENT_MAP,
		map
	}
}

export function clearCurrentMap() {
	return {
		type : SET_CURRENT_MAP,
		map : null
	}
}


export function updateMapSearchList(maps) {
	return {
		type : UPDATE_MAP_SEARCH_LIST,
		maps
	}
}

export function searchingMaps() {
	return {
		type : SEARCHING_MAPS
	}
}

export function doneSearchingMaps() {
	return {
		type : DONE_SEARCHING_MAPS
	}
}

export const setPurchaseMap = (map) => {
	return {
		type : SET_PURCHASE_MAP,
		map
	}
}

export const showPurchaseMap = (map) => {

	return (dispatch, getState) => {
		if(typeof map === 'string') { //If we get a map id, try to find the object in the state.
			var maps = getState().maps.array;
			for (var i = 0; i < maps.length; i++) {
				if(maps[i]._id == map)
					map = maps[i];
			};
		}

		if(typeof map === 'object') {

			dispatch(setPurchaseMap(map))
			dispatch({
				type : SHOW_PURCHASE_MAP
			});

		}
		else
			console.error("You must provide a valid map object.");
	}
}

export const hidePurchaseMap = () => {
	return (dispatch) => {
		dispatch(setPurchaseMap(null));
		dispatch({
			type : HIDE_PURCHASE_MAP
		})
	}
}

//Input: Date string in format MM/DD/YYYY
//Result: Gets storm data and updates the global state with it.
export const getStormData = (date, callback) => {
	var momentDate = moment(date,'MM/DD/YYYY');
	return (dispatch) => {
		dispatch(updateStormData(null));
		callApi('GET',`/maps/storm_reports/${ momentDate.format('MMDDYY') }`, null, 'application/json')
			.then(stormData => {
				dispatch(updateStormData(stormData));
				if(callback) {
					callback( null, stormData);
				}
			})
			.catch(error => {
				dispatch(updateStormData(null));
				dispatch(notify(error));
				if(callback) {
					callback(error, null);
				}
			});
	}
}

//TODO: Proposed change:
// Make this function more versatile. Instead of passing
// coordinates pass a search object with properties {coordinates, range, offset}
// range: {start , end} -- dates
// coordinates : [lng,lat]
// offset : Number (usefull for pagination or "see more" implementation)
// limit : Number (usefull for pagination)
// radius : size of the circle to search.
export function searchMaps(query, callback) {
	return function(dispatch) {
		dispatch(updateDate(null));
		dispatch(searchingMaps());
		if(typeof query.coordinates !== 'undefined')
			query.coordinates = JSON.stringify(query.coordinates);

		callApi('POST', `/maps/search`, query, 'application/json')
			.then(maps => {
				dispatch(updateMapSearchList(maps));
				dispatch(doneSearchingMaps());
				if(callback)
					callback(null, maps);//Expressjs style error handling.
			})
			.catch(error => {
				dispatch(doneSearchingMaps());
				if(callback)
					callback(error, null);
			});
	}
}

//TODO: Proposed change:
// Move start_date, end_date to a "range" object passed as a single parameter.
// dateRange { start, end }
export function getMapsByDate(start_date, end_date, callback) {
	return function(dispatch) {
		callApi('POST', `/maps/search/by_date`, { start_date, end_date }, 'application/json')
			.then(maps => {
				dispatch(updateDate(start_date));
				dispatch(updatePlaces([]));
				dispatch(updateMapSearchList(maps));
				if (callback) {
					callback(null, maps);
				}
			})
			.catch(error => {
				dispatch(notify(error));
				if(callback) {
					callback(error, null);
				}
			});
	}
}

export function getNewestMaps(newest, callback) {
	return function(dispatch) {
		callApi('POST', '/maps/search/newest', { newest }, 'application/json')
			.then(maps => {
				if(callback) {
					callback(null, maps);
				}
			})
			.catch(error => {
				if(callback) {
					callback(error, null);
				}
			});
	}
}

/*
This should likely be changed to a GET request.
There is no reason to send a Boolean simply so that the function call to handleMapSearch knows to execute the 'favorites' block.
The User API should be reorganized when possible, due to this reason, and since similar absurdities exist elsewhere.
- Ben
*/
export function getFavoriteMaps(favorites, callback) {
	return function(dispatch) {
		callApi('POST', '/maps/search/favorites', { favorites }, 'application/json')
			.then(maps => {
				if(callback) {
					callback(null, maps);
				}
			})
			.catch(error => {
				if(callback) {
					callback(error, null);
				}
			})
	}
}

export function getRecentlyViewedMaps(recently_viewed, callback) {
	return function(dispatch) {
		callApi('POST', '/maps/search/recently_viewed', { recently_viewed }, 'application/json')
			.then(maps => {
				if(callback) {
					callback(null, maps);
				}
			})
			.catch(error => {
				if(callback) {
					callback(error, null);
				}
			});
	}
}

//To save a map to the database.
export function saveMap(map,callback,error) {
	return function(dispatch,getState) {
		map = JSON.stringify(map);

		callApi('POST', '/map', { map }, 'application/json')
			.then(map => {
				if(error) {
					callback(map);
				}
				else {
					callback(null, map);
				}
			})
			.catch(err => {
				if(error) {
					error(err);
				}
				else {
					callback(null, map);
				}
			});
	}
}

// export function saveEditedMap(map,callback) {
// 	return function(dispatch, getState) {
// 		map = JSON.stringify(map);
//
// 		callApi('PUT', '/map', { map }, 'application/json')
// 			.then(map => {
// 				if(callback) {
// 					callback(null, map);
// 				}
// 			})
// 			.catch(err => {
// 				if(err) {
// 					callback(err, null);
// 				}
// 			})
// 	}
// }

export function getMap(id,callback) {
	return function(dispatch,getState) {
		callApi('GET', `/map/${ id }`, null, 'application/json')
			.then(map => {
				dispatch(setCurrentMap(map)); //TODO: See if this is a wise way of doing this.

				//Update the storm data for this map.
				var date = moment(map.properties.storm_date.slice(0,10), "YYYY-MM-DD").format('MM/DD/YYYY');
				dispatch(getStormData(date));

				if(callback) {
					callback(null, map);
				}
			})
			.catch(err => {
				if(err.status == 403) {
					dispatch(showPurchaseMap(err.map));
				}
				else {
					dispatch(notify(err));
				}
				if(callback) {
					callback(err,null);
				}
			});
	}
}

export function getEditableMap(id,callback) {
	return function(dispatch,getState) {
		callApi('GET', `/map/edit/${ id }`, null, 'application/json')
			.then(map => {
				dispatch(setCurrentMap(map)); //TODO: See if this is a wise way of doing this.
				if(callback)
					callback(null, map);
			})
			.catch(err => {
				if(callback)
					callback(err, null);
			});
	}
}

export function getEditableMapsByDate(date, callback) {
	return (dispatch) => {
		callApi('POST', '/maps/search/detailed', { date }, 'application/json')
			.then(maps => {
				if(callback) {
					callback(null, maps);
				}
			})
			.catch(error => {
				if(callback) {
					callback(error, null);
				}
			});
	}
}

//To update a map in the database.
export function updateMap(map,callback) {
	return function(dispatch,getState) {
		map = JSON.stringify(map);

		callApi('PUT', `/map/${ map._id }`, { map }, 'application/json')
			.then(map => {
				if(callback) {
					callback(null, map);
				}
			})
			.catch(err => {
				if(error) {
					callback(err, null);
				}
			});
	}
}

//To remove a map from the database.
export function removeMap(map, callback) {
	return function(dispatch) {
		//TODO: Dispatch Action Creator
	}
}

// add associated restriction on api call
export function getMapsOwnedByUserId(user_id, callback) {
	return function(dispatch, getState) {
		callApi('GET', `/maps/load/${ user_id }`, null, 'application/json')
			.then(maps => {
				if(callback) {
					callback(null, maps);
				}
			})
			.catch(err => {
				if(callback) {
					callback(err, null);
				}
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/map.js